<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="isVisibleCustomerTransactionDetail"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'800px'}">
    <ng-template pTemplate="header">
        <div class="flex flex-row">
            <div class="verification-head">
                <div class="verification-head__title">TX ID: {{transactionId}}</div>
            </div>
        </div>
    </ng-template>
    <div>
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 107px)'}"
                       [styleClass]="'app-scrollpanel'">
            <p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>
            <div class="customer-info-body" *ngIf="activeMenuTab === menuTab.OrderDetails">
                <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 230px)'}"
                               [styleClass]="'app-scrollpanel'">
                    <div>
                        <div class="transaction-info-title">Xpress Transaction</div>
                        <div class="flex flex-row flex-wrap">
                            <div class="col-6 p-0">
                                <div class="flex flex-row flex-wrap">
                                    <div class="col-6 p-0 mb-2">Transaction date:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction?.TransactionDate}}</div>
                                    <div class="col-6 p-0 mb-2">Transaction time:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction?.TransactionTime}}</div>
                                    <div class="col-6 p-0 mb-2">Transaction type:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction?.TransactionTypeText}}</div>
                                    <div class="col-6 p-0 mb-2">Promo:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction?.PromoOrderUsePercent}}%</div>
                                    <div class="col-6 p-0 mb-2">Promo Funded:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">
                                        {{(transaction?.PromoOrderFunded) ? transaction?.PromoOrderFunded : 'N/A'}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 p-0">
                                <div class="flex flex-row flex-wrap">
                                    <div class="col-6 p-0 mb-2">Payment method:</div>
                                    <div class="col-6 p-0 mb-2">
                                        {{(transaction?.PaymentMethodText) ? transaction?.PaymentMethodText : 'N/A'}}
                                    </div>
                                    <div class="col-6 p-0 mb-2">Transaction amount:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction?.TransactionAmount}}</div>
                                    <div class="col-6 p-0 mb-2">Transaction status:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">
                                        <span *ngIf="transaction?.TransactionStatus === 'PAID'" class="transaction-color-green">Success</span>
                                        <span *ngIf="transaction?.TransactionStatus !== 'PAID'">{{transaction?.TransactionStatus}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="transaction-border-bottom"></div>
                    <div>
                        <div class="flex flex-row flex-wrap">
                            <div class="col-6 p-0">
                                <div class="transaction-info-title">Payment Processor:</div>
                                <div class="flex flex-row flex-wrap">
                                    <div class="col-6 p-0 mb-2">Partner</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">Xendit</div>
                                    <div class="col-6 p-0 mb-2">TX time:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction?.TransactionTime}}</div>
                                    <div class="col-6 p-0 mb-2">Reference:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction?.RequestRefNumber}}</div>
                                    <div class="col-6 p-0 mb-2">Status:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">
                                        <span *ngIf="transaction?.IsPaid" class="transaction-color-green">Success</span>
                                        <span *ngIf="!transaction?.IsPaid">Unsuccessfully</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 p-0">
                                <div class="transaction-info-title">Wallet History:</div>
                                <div class="flex flex-row flex-wrap">
                                    <div class="col-6 p-0 mb-2">Previous Balance:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction?.PreviousWalletBalance}}</div>
                                    <div class="col-6 p-0 mb-2">New Balance:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction?.CurrentWalletBalance}}</div>
                                    <span style="margin-top: -8px; font-size: 12px" class="new-balance-clarification">(After Top up)</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="transaction-border-bottom"></div>
                    <div>
                        <div class="flex flex-row flex-wrap">
                            <div class="col-6 p-0">
                                <div class="transaction-info-title">Order Timeline</div>
                                <div>
                                    <div class="transaction-order-process-title mb-2">Order Processing</div>
                                    <div class="flex flex-row flex-wrap">
                                        <ng-container *ngFor="let item of transaction?.OrderProcessings">
                                            <div class="col-6 p-0 mb-2">{{item.TransactionTypeName}}:</div>
                                            <div class="col-6 p-0 mb-2 transaction-value">{{item.CreatedAt}}</div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 p-0">
                            </div>
                        </div>
                    </div>
                </p-scrollPanel>
            </div>
        </p-scrollPanel>
    </div>
</p-sidebar>
